import * as React from 'react';
import './ProjectText.css';
import { ClassNames } from '../../_helpers/ClassNames';

export type ProjectTextProps = ProjectTextDto;

export class ProjectText extends React.Component<ProjectTextProps> {

    constructor(props: ProjectTextProps) {
        super(props);
    }

    render() {
        const { Text, Title } = this.props;
        return (
            <div className={ClassNames("project-text", "")}>
                {Title && 
                    <h3 className={ClassNames("project-text", "title")}>{Title}</h3>
                }
                <div className={ClassNames("project-text", "text")} dangerouslySetInnerHTML={{__html: Text}}/>
            </div>
        );
    }
}

export default ProjectText;


// WEBPACK FOOTER //
// ./src/Components/ProjectText/ProjectText.tsx